import { useRouteError } from 'react-router';
import { Button } from '@helios/ui';

function isModuleLoadFailure(error: unknown): boolean {
  return (
    error instanceof Error &&
    (error.name === 'ChunkLoadError' ||
      /failed to fetch dynamically imported module|importing a module script failed|error loading dynamically imported module|loading (?:css )?chunk .+ failed/i.test(
        error.message,
      ))
  );
}

/** Root recovery stays eager and independent of the failed lazy page/providers. */
export function RouteRecoveryPage({
  reload = () => window.location.reload(),
}: {
  reload?: () => void;
}) {
  const moduleFailed = isModuleLoadFailure(useRouteError());

  return (
    <main
      className="bg-background text-foreground flex min-h-screen items-center justify-center p-6"
      aria-labelledby="route-recovery-title"
    >
      <section className="border-border bg-card w-full max-w-lg space-y-4 rounded-xl border p-6">
        <p className="text-muted-foreground text-xs font-medium">HELIOS ConstructionOS</p>
        <h1 id="route-recovery-title" className="text-xl font-semibold">
          {moduleFailed ? 'This page needs to be reloaded' : 'This page could not be opened'}
        </h1>
        <p className="text-muted-foreground text-sm">
          {moduleFailed
            ? 'A required app file could not be loaded. The app may have been updated, or your network connection may have been interrupted.'
            : 'An unexpected error interrupted this page. Reload the current page to try again. If it continues, contact your administrator.'}
        </p>
        <p id="route-recovery-warning" className="text-muted-foreground text-sm">
          Reloading may discard unsaved changes. Nothing will reload until you choose to continue.
        </p>
        <Button onClick={() => reload()} aria-describedby="route-recovery-warning">
          Reload current page
        </Button>
      </section>
    </main>
  );
}
